import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/bars-tables";
const BarTableApi = {
  barTable(params: any): Promise<any> {
    const url = `${path}/list`;
    return api.get(url, params);
  },

  createBarTable(params: any) {
    return api.post(path, params);
  },

  updateBarTable(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteBarTable(id: any) {
    return api.delete(`${path}/${id}`);
  },

  updateStatusBarTable(params: any) {
    return api.patch(`${path}/update-status`, params);
  },
};

export default BarTableApi;
